import splitFactory from '@app/splitio';

// Types
export const FETCH_FEATURES_SUCCESS = 'chama/features/FETCH_FEATURES_SUCCESS';
export const UPDATE_FEATURES_SUCCESS = 'chama/features/UPDATE_FEATURES_SUCCESS';

export const initialState = {
  featuresFetched: false,
  features: {},
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_FEATURES_SUCCESS:
      return {
        ...state,
        featuresFetched: true,
        features: action.payload,
      };
    case UPDATE_FEATURES_SUCCESS:
      return {
        ...state,
        features: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
export function featuresFetchSuccess(features) {
  return { type: FETCH_FEATURES_SUCCESS, payload: features };
}
export function featuresUpdateSuccess(features) {
  return { type: UPDATE_FEATURES_SUCCESS, payload: features };
}

const trackedTreatments = ['User_RestrictionAreas_Import_Frontend'];

// Side Effects
export const startListeningToFeatures = () => (dispatch, getState) => {
  const {
    auth: { uid },
  } = getState();
  const client = splitFactory.client(uid, 'user');

  client.on(client.Event.SDK_READY, () => {
    const treatments = client.getTreatments(trackedTreatments);
    dispatch(featuresFetchSuccess(treatments));
  });
  client.on(client.Event.SDK_UPDATE, () => {
    const treatments = client.getTreatments(trackedTreatments);
    dispatch(featuresUpdateSuccess(treatments));
  });
};

// Selectors
export const selectors = {
  isUnderToggle({ features: { features } }, rules) {
    return Object.entries(rules).every(isValueWithinRule, { features });
  },

  isRestrictionAreasImportEnabled: ({ features: { features } }) =>
    features.User_RestrictionAreas_Import_Frontend === 'on',
};

//  if the feature is not on the rules, we treat it as valid
function isValueWithinRule([key, possibilities]) {
  const value = this.features[key];

  return value ? possibilities.includes(value) : true;
}



// WEBPACK FOOTER //
// ./src/modules/features/redux.js